import { saveAs } from "file-saver";
import isElectron from "is-electron";

/**
 * Download a file without opening a blank Electron/browser window.
 * Cross-origin file service URLs cannot rely on <a download>.
 */
export async function downloadFile(url, fileName) {
  if (!url) return;

  const name = (fileName || "download").trim() || "download";

  try {
    const response = await fetch(url, { credentials: "omit" });
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }
    const blob = await response.blob();
    saveAs(blob, name);
  } catch (error) {
    // Fallback: let Electron/browser handle it without target=_blank.
    if (isElectron() && window.wunityDesktop && window.wunityDesktop.downloadUrl) {
      window.wunityDesktop.downloadUrl(url);
      return;
    }
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

export function isFileServiceUrl(url) {
  try {
    const parsed = new URL(url, window.location.href);
    if (parsed.port === "3007") return true;
    const configured = window.config && window.config.apiFileServiceUrl;
    if (configured) {
      const base = new URL(configured);
      return parsed.origin === base.origin;
    }
    return false;
  } catch (error) {
    return false;
  }
}
